const OnlineAttendanceRoutes = [
    {
        path: '/timeattendance/manual',
        component: () => import('@/views/TimeAttendance/ManualView.vue'),
    },
    {
        path: '/timeattendance/holiday',
        component: () => import('@/views/TimeAttendance/HolidayView.vue'),
    },
    {
        path: '/timeattendance/fingerprintDevice',
        component: () => import('@/views/TimeAttendance/Fingerprint/index.vue'),
    },
    {
        path: '/timeattendance/fingerprintDeviceDetail/:id',
        component: () => import('@/views/TimeAttendance/Fingerprint/components/FingerprintDeviceDetails.vue'),
        props: true,
    },
    {
        path: '/timeattendance/auto-time',
        component: () => import('@/views/TimeAttendance/AutoCorrectTimeView.vue'),
    },
    {
        path: '/timeattendance/report',
        component: () => import('@/views/TimeAttendance/AttendanceReportView.vue'),
    },
    {
        path: '/timeattendance/all-records',
        component: () => import('@/views/TimeAttendance/AttendanceRecordListView.vue'),
    },
    {
        path: '/timeattendance/setup',
        component: () => import('@/views/TimeAttendance/data-setup/SetupView.vue'),
    },
    {
        path: '/timeattendance/top-employee',
        component: () => import('@/views/TimeAttendance/TopEmployeeView.vue'),
    },
    {
        path: '/timeattendance/face-attendance',
        component: () => import('@/views/TimeAttendance/FaceAttendance/FaceAttendanceRecord.vue'),
    },
    {
        path: '/calendar',
        component: () => import('@/views/Calendar/CalendarView.vue'),
    },

    {
        name: 'OnlineAttendanceReport',
        path: '/OnlineAttendance/OnlineAttendanceReport',
        component: () => import('@/views/TimeAttendance/OnlineAttendance/OnlineAttendanceReportView.vue'),
    },
    {
        path: '/timeattendance/online-attendance',
        name: 'OnlineAttendance',
        component: () => import('@/views/TimeAttendance/OnlineAttendance/OnlineAttendanceRecordView.vue'),
    },
    {
        path: '/OnlineAttendance/WorkingLocation',
        component: () => import('@/views/TimeAttendance/OnlineAttendance/WorkingLocationView.vue'),
    },
    {
        path: '/onlineAttendance/SetWorkingLocation',
        component: () => import('@/views/TimeAttendance/OnlineAttendance/SetWorkingLocationView.vue'),
    },
]

export default OnlineAttendanceRoutes
